const constants = () => {
  return {
    body: {
      // ToDo: Start sending lastEvaluatedKey when pagination is implement.
      lastEvaluatedKey: null,
    },
  };
};
export default constants;
